<template>
  <div>
    <UIProgressCircular v-if="dataLoading" />
    <v-container v-else>
      <v-row>
        <v-col
          class="d-none d-sm-flex"
          sm="1"
          lg="2"
          xl="3"
        />
        <v-col
          cols="12"
          sm="10"
          lg="8"
          xl="6"
          class="pt-4"
          :class="$vuetify.breakpoint.xs ? 'px-0' : 'px-4'"
        >
          <nav class="back-pages-navigation">
            <ButtonGoBack />
            <ButtonGoTo
              location="/spm/events"
              title="К списку мероприятий"
              icon="table-arrow-left"
            />
          </nav>

          <h2 class="text-center">
            {{ filledForm.formTemplate ? filledForm.formTemplate.event.name : '' }}
          </h2>

          <v-alert
            v-if="!isShowForm && filledForm.status && filledForm.status.isCommentNeeded"
            outlined
            color="primary"
            class="my-4"
          >
            <strong>Отправлено на доработку.</strong>
            <div>Причина: {{ filledForm.comment }}</div>
          </v-alert>

          <v-alert
            v-if="isShowForm"
            outlined
            class="my-4 ui-alert ui-alert-warning"
          >
            <v-icon class="uikit-icon info-icon warningIcon" />
            <span class="ml-2">Вы в режиме просмотра формы</span>
          </v-alert>

          <div
            v-for="block in filterBlocks(isOperatorRoles, isManualRegistration, isShowForm)"
            :key="block.id"
          >
            <v-card
              v-if="getBlockVisibility(block, isOperatorRoles, isShowForm)"
              class="base-card my-4 text-justify text-pre-wrap"
            >
              <v-card-title class="d-flex justify-center">
                {{ block.name }}
              </v-card-title>
              <v-card-text>
                <template v-for="field in filterFieldsByBlock(block, isOperatorRoles, isManualRegistration, isShowForm)">
                  <component
                    :is="field.getFieldComponentName"
                    :key="field.id + '-' + field.fieldType.id"
                    :type="field.getType"
                    :label="field.name"
                    :value="fieldValue(field) && fieldValue(field).value"
                    :items="directories[field.id]"
                    :required="field.isRequired"
                    :hint="field.comment"
                    :counter="field.size"
                    :error-messages="errorMessages[field.id]"
                    :return-object="true"
                    :disabled="!isOperatorRoles && !availableStatusList.length"
                    @input="$v.fieldValueList.list.$touch()"
                    @change="inputField($event, fieldValue(field))"

                    @addFile="addFile($event, fieldValue(field))"
                    @downloadFile="downloadFile($event, fieldValue(field))"
                    @selectFile="selectFile($event, fieldValue(field))"
                    @removeFile="removeFile($event, fieldValue(field))"
                  />
                </template>

                <div
                  v-for="(subBlock, i) in filterSubBlockByBlock(block, isOperatorRoles, isManualRegistration, isShowForm)"
                  :key="subBlock.id"
                >
                  <template v-if="filterFieldsBySubBlock(subBlock, isOperatorRoles, isManualRegistration, isShowForm).length">
                    <h3 class="pb-2 d-flex justify-center">
                      {{ subBlock.name }}
                    </h3>
                    <template v-for="field in filterFieldsBySubBlock(subBlock, isOperatorRoles, isManualRegistration, isShowForm)">
                      <component
                        :is="field.getFieldComponentName"
                        :key="field.id + '-' + field.fieldType.id"
                        :type="field.getType"
                        :label="field.name"
                        :value="fieldValue(field) && fieldValue(field).value"
                        :items="directories[field.id]"
                        :hint="field.comment"
                        :counter="field.size"
                        :required="field.isRequired"
                        :error-messages="errorMessages[field.id]"
                        :return-object="true"
                        :disabled="!isOperatorRoles && !availableStatusList.length"
                        @input="$v.fieldValueList.list.$touch()"
                        @change="inputField($event, fieldValue(field))"

                        @addFile="addFile($event, fieldValue(field))"
                        @downloadFile="downloadFile($event, fieldValue(field))"
                        @selectFile="selectFile($event, fieldValue(field))"
                        @removeFile="removeFile($event, fieldValue(field))"
                      />
                    </template>

                    <v-divider
                      v-if="i + 1 !== filterSubBlockByBlock(block, isOperatorRoles, isManualRegistration, isShowForm).length"
                      class="my-2"
                    />
                  </template>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <div
            v-if="(!isOperatorRoles || isManualRegistration) && !isShowForm"
            class="mt-4 d-flex flex-column justify-center"
          >
            <v-btn
              v-if="availableStatusList.length"
              color="primary"
              class="action-btn elevation-0 rounded-lg"
              :loading="loading"
              :disabled="$v.$invalid"
              @click="isSendForm = true"
            >
              <span class="btn-text">Отправить форму</span>
            </v-btn>
            <p
              v-if="filledForm.status"
              class="mt-4 text-center"
            >
              Форма находится в статусе "{{ filledForm.status.name }}"
            </p>
          </div>
          <div
            v-else-if="!isManualRegistration && !isShowForm"
            class="d-flex justify-end mb-6"
          >
            <MenuButton
              :name="filledForm.status.name"
              :filled-form-id="filledForm.id"
              @changeFilledFormStatus="changeFilledFormStatus($event)"
              @sendToRevision="openSendToRevisionDialog($event)"
            />
          </div>
        </v-col>
        <v-col
          class="d-none d-sm-flex"
          sm="1"
          lg="2"
          xl="3"
        />
      </v-row>
    </v-container>

    <AcceptDialog
      :dialog="badgeDialog"
      :message="`Распечатать бейдж?`"
      :loading="badgeLoading"
      @confirm="printBadge"
      @closeConfirmModal="closeBadgeDialog"
    />

    <AcceptDialog
      :dialog="isSubmittedForm || leavingPage"
      :message="messageForNextManualRegistration"
      :loading="dataLoading"
      @confirm="confirmNextManualRegistration"
      @closeConfirmModal="closeNextManualRegistration"
      @closeModal="isSubmittedForm = false; leavingPage = false"
    />

    <AcceptDialog
      :dialog="isSendForm"
      message="Данное действие нельзя отменить"
      :loading="loading"
      success-btn-text="Отправить"
      cancel-btn-text="Отмена"
      @confirm="toSendForm(); isSendForm = false"
      @closeConfirmModal="isSendForm = false"
    />

    <SendToRevisionDialog
      style="position: absolute"
      :dialog="sendToRevisionDialog"
      @sendToRevision="changeFilledFormStatus(selectedSendToRevisionStatus, $event)"
      @closeModal="closeSendToRevisionDialog"
    />
  </div>
</template>

<script>
import UITextField from '@/ui/input/UITextField'
import UIDatePickerMenu from '@/ui/input/UIDatePickerMenu'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'
import UIRating from '@/ui/rating/UIRating'
import UIFilesInput from '@/ui/input/file/UIFilesInput'
import UIBooleanRadioButtons from '@/ui/input/radioButtons/UIBooleanRadioButtons'
import UIAutocomplete from '@/ui/input/UIAutocomplete'
import UICheckbox from '@/ui/input/UICheckbox'
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex'
import {
  integer,
  decimal,
  email,
  requiredIf,
} from 'vuelidate/lib/validators'
import { customMaxLength, setValidateMessages } from '@/scripts/validation'
import {
  badgeApi,
  fileApi, filledFormApi,
  userFileValueApi,
} from '@/api'
import { FieldType } from '@/enums'
import download from '@/plugins/download'
import { FieldValue } from '@/models'
import ButtonGoBack from '@/featureSlicedDesign/features/ButtonGoBack'
import AcceptDialog from '@/components/dialogs/AcceptDialog'
import printJS from 'print-js'
import { FillingFormType } from '@/enums/fillingFormType'
import MenuButton from '@/components/Spm/Events/FilledFormValuePage/elements/MenuButton'
import SendToRevisionDialog from '@/components/Spm/Events/FilledFormValuePage/dialogs/SendToRevisionDialog'
import { getSessionStorageKey, removeSessionStorageKey, setSessionStorageKey } from '@/scripts/sessionStorage'
import ButtonGoTo from '@/featureSlicedDesign/features/ButtonGoTo'
import { FieldTypeId } from '../../enums/fieldType'

export default {
  name: 'FillingForm',
  components: {
    ButtonGoTo,
    AcceptDialog,
    SendToRevisionDialog,
    MenuButton,
    ButtonGoBack,
    UIAutocomplete,
    UIBooleanRadioButtons,
    UIProgressCircular,
    UIDatePickerMenu,
    UITextField,
    UIRating,
    UIFilesInput,
    UICheckbox,
  },

  metaInfo: { title: 'Форма' },

  beforeRouteLeave(to, from, next) {
    if (this.isManualRegistration && !this.leave) {
      this.leavingPage = true
      this.messageForNextManualRegistration = 'Продолжить регистрацию?'
      next(false)
    } else {
      next()
    }
  },

  async created() {
    this.showHtmlOverflow()
    this.isManualRegistration = this.$route.params.type === FillingFormType.MANUAL_REGISTRATION
    this.isPersonalRegistration = this.$route.params.type === FillingFormType.PERSONAL_REGISTRATION
  },

  destroyed() {
    this.hideHtmlOverflow()
  },

  async mounted() {
    await this.loadingData()
  },

  data: () => ({
    loading: false,
    badgeDialog: false,
    badgeLoading: false,
    isManualRegistration: false,
    isPersonalRegistration: false,
    availableStatusList: [],
    sendToRevisionDialog: false,
    selectedSendToRevisionStatus: null,
    leavingPage: false,
    isSubmittedForm: false,
    messageForNextManualRegistration: '',
    leave: false,
    isSendForm: false,
  }),

  validations() {
    return {
      fieldValueList: {
        list: {
          $each: {
            value: {
              required: requiredIf((field) => field.field?.isRequired),
              booleanRequired(value, field) {
                const fieldType = field?.field?.fieldType?.id
                const isRequired = field?.field?.isRequired

                if (!isRequired) return true

                if (fieldType === FieldTypeId.Checkbox) {
                  return value === true
                }

                if (fieldType === FieldTypeId.RadioButton) {
                  return value !== null && value !== undefined && value !== ''
                }
                return true
              },
              integer(value, field) {
                if (field?.field?.fieldType?.id === FieldType.NUMBER) return integer(value)
                return true
              },
              decimal(value, field) {
                if (field?.field?.fieldType?.id === FieldType.FRACTIONAL) return decimal(value)
                return true
              },
              email(value, field) {
                if (field?.field?.fieldType?.id === FieldType.EMAIL) return email(value)
                return true
              },
              customMaxLength(value, field) {
                return field?.field?.fieldType?.id === FieldType.TEXT ? customMaxLength(field?.field?.size, value) : true
              },
            },
          },
        },
      },
    }
  },

  computed: {
    ...mapGetters('form', [
      'dataLoading',
      'blocks',
      'filterBlocks',
      'fields',
      'subBlocks',
      'formTemplate',
      'filterFieldsByBlock',
      'filterSubBlockByBlock',
      'filterFieldsBySubBlock',
      'fieldValue',
      'fieldValueList',
      'filledForm',
      'directories',
    ]),
    ...mapGetters('user', ['isOperatorRoles']),

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.fieldValueList.list.$each.$params)
        .forEach((key) => {
          allErrors[this.$v.fieldValueList.list.$each[key].$model.field?.id] = setValidateMessages(this.$v.fieldValueList.list.$each[key].value)
        })

      return allErrors
    },

    isShowForm() {
      return this.$route.params.type === FillingFormType.SHOW
    },
  },

  methods: {
    ...mapActions('form', [
      'getForm',
      'createFilledForm',
      'saveFieldValue',
      'getFilledForm',
      'sendForm',
      'fillFormWithEmptyData',
      'getFilledFormByFillingForm',
      'removeFilledForm',
    ]),

    ...mapMutations('form', [
      'clearConstructorParams',
      'setDataLoading',
      'updateFieldElement',
    ]),

    async confirmNextManualRegistration() {
      if (this.isSubmittedForm) {
        this.$v.$reset()
        await this.loadingData()
      }
      this.isSubmittedForm = false
      this.leavingPage = false
    },

    async closeNextManualRegistration() {
      if (this.leavingPage) {
        await this.removeFilledForm()
      }
      this.leavingPage = false
      this.isSubmittedForm = false
      removeSessionStorageKey('filled-form')
      this.leave = true
      this.$router.push(`/spm/events/${this.formTemplate.event.id}/formTemplatePage`)
      this.messageForNextManualRegistration = ''
    },

    async loadingData() {
      this.setDataLoading({ loading: true })

      this.clearConstructorParams()
      await this.getForm(this.$route.params.id)
      if (this.isManualRegistration) {
        if (+getSessionStorageKey('filled-form')) {
          await this.getFilledFormByFillingForm(+getSessionStorageKey('filled-form'))
        } else {
          await this.createFilledForm({ isManualRegistered: true })
          setSessionStorageKey('filled-form', this.filledForm.id)
        }
      } else if (this.isPersonalRegistration) {
        await this.getFilledForm(this.$route.params.id)
      } else if (this.$route.params.type === FillingFormType.ADMIN_EDIT) {
        if (this.isOperatorRoles) {
          await this.getFilledFormByFillingForm(this.$route.params.fillingFormId)
        } else {
          this.$router.push('/')
          this.showErrorMessage({ status: 0 }, 'Нет прав')
        }
      }

      if (this.$route.params.type !== FillingFormType.SHOW) {
        await this.getAvailableStatuses()
        await this.fillFormWithEmptyData()
      }

      this.setDataLoading({ loading: false })
    },

    async inputField(value, fieldValue) {
      try {
        !this.isShowForm && await this.saveFieldValue({ fieldValue, value })
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка обновления данных')
      }
    },

    async toSendForm() {
      this.$v.$touch()

      const hasCheckboxError = (this.fieldValueList?.list || []).some((item) => {
        const fieldMeta = item.field

        return (
          fieldMeta
      && fieldMeta.fieldType?.id === 11
      && fieldMeta.isRequired
      && item.value !== true
        )
      })

      if (hasCheckboxError) {
        const errorNames = (this.fieldValueList?.list || [])
          .filter((item) => {
            const fm = item.field
            return fm && fm.fieldType?.id === 11 && fm.isRequired && item.value !== true
          })
          .map((item) => `"${item.field.name}"`)

        const msg = `Необходимо заполнить следующие обязательные пункты:\n\n- ${errorNames.join('\n- ')}`

        this.$toastr('error', msg.replace(/\n/g, '<br>'), 'Ошибка заполнения')

        return
      }

      try {
        this.loading = true

        await this.sendForm({ statusId: this.availableStatusList[0]?.id })

        this.$toastr('success', '', 'Форма успешно отправлена')

        if (this.isManualRegistration) {
          this.badgeDialog = true
          removeSessionStorageKey('filled-form')
        } else {
          await this.loadingData()
        }
      } catch (e) {
        this.showErrorMessage(e, e.data.message || 'Ошибка при отправке')
      } finally {
        this.loading = false
      }
    },

    async addFile(file, field) {
      try {
        if (!this.isShowForm) {
          const data = await fileApi.postFiles(
            [file],
            this.filledForm.id,
            `${field.field.id}-${field.field.fieldType.id}`,
          )

          const body = {
            files: [...field.value, ...data],
            filledForm: this.filledForm,
            id: field.id,
            userfile: field.field,
            field: field.field,
          }

          const resData = field.id ? await userFileValueApi.update(body)
            : await userFileValueApi.create(body)

          const updateBody = resData
          updateBody.field = field.field
          updateBody.value = resData.files

          this.updateFieldElement({ fieldValue: updateBody })
        }
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки файла')
      }
    },

    getBlockVisibility(block, isOperatorRoles, isShowForm) {
      const isHasFieldsByBlock = () => Boolean(
        this.filterFieldsByBlock(block, isOperatorRoles, this.isManualRegistration, isShowForm).length,
      )

      const isHasSubBlockByBlock = () => Boolean(
        this.filterSubBlockByBlock(block, isOperatorRoles, this.isManualRegistration, isShowForm)
          .some((subBlock) => this.filterFieldsBySubBlock(
            subBlock,
            isOperatorRoles,
            this.isManualRegistration,
            isShowForm,
          ).length && !subBlock.isHidden),
      )

      return isOperatorRoles || isHasFieldsByBlock() || isHasSubBlockByBlock()
    },

    async downloadFile(file) {
      try {
        const data = await fileApi.getFile(file.id)
        download(data, file.name)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      }
    },

    selectFile(file, field) {
      // Выбор файла для показа pdf
    },

    async closeBadgeDialog() {
      this.badgeDialog = false
      try {
        this.isSubmittedForm = true
        this.messageForNextManualRegistration = 'Перейти к регистрации следующего пользователя?'
        // await this.loadingData()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка обновления формы')
      }
    },

    async printBadge() {
      try {
        this.badgeLoading = true
        const badge = await badgeApi.uploadIndividualBadgePDF(this.filledForm.id)
        printJS({ printable: badge.slice(badge.indexOf(',') + 1), type: 'pdf', base64: true })
      } catch (error) {
        console.log(error)
        this.showErrorMessage(error, 'Не удалось распечатать бейдж')
      } finally {
        this.badgeLoading = false
        this.closeBadgeDialog()
      }
    },

    async removeFile(file, field) {
      try {
        if (!this.isShowForm) {
          await fileApi.deleteFile(file.id)

          const body = new FieldValue(field)
          body.value = field.value.filter((el) => el.id !== file.id)
          body.files = body.value
          const resData = await userFileValueApi.update(body.getForAPI())

          const updateBody = resData
          updateBody.field = field.field
          updateBody.value = resData.files

          this.updateFieldElement({ fieldValue: updateBody })
        }
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      }
    },

    async getAvailableStatuses() {
      try {
        this.availableStatusList = await filledFormApi.findAchievableStatuses(this.filledForm.id)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения доступных статусов')
      }
    },

    openSendToRevisionDialog(statusId) {
      this.sendToRevisionDialog = true
      this.selectedSendToRevisionStatus = statusId
    },

    closeSendToRevisionDialog() {
      this.sendToRevisionDialog = false
      this.selectedSendToRevisionItem = null
      this.selectedSendToRevisionStatus = null
    },

    async changeFilledFormStatus(statusId, comment = '') {
      try {
        const filledFormChangeStatusDto = {
          comment,
          filledFormId: this.filledForm.id,
          filledFormStatusNew: { id: statusId },
        }
        await filledFormApi.changeFilledFormStatus(filledFormChangeStatusDto)
        this.closeSendToRevisionDialog()
        await this.loadingData()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка')
      }
    },

    hideHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'hidden'
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    },
  },
}
</script>
